import storageService from "../services/StorageService";
import { localstorageKeys } from "@const/store";
import { REDIRECT_PATHS } from "@pages/AuthRedirects";
import routes from "../const/routes";

export default (navigate) => {
  const { pathname } = window.location;
  const destination = storageService.get(localstorageKeys.destination);
  if (!destination && !REDIRECT_PATHS.includes(pathname)) return;
  if (!REDIRECT_PATHS.includes(pathname) && destination.includes(pathname)) {
    storageService.remove(localstorageKeys.destination);
    return;
  }
  storageService.remove(localstorageKeys.destination);
  navigate(destination || routes.FEED(), {
    replace: true,
    state: { from: pathname },
  });
};
